import { MISSION_BY_ID } from '../../data/missions';
import { HUMAN_PLAYER_INDEX } from '../../domain/types';
import { useGameStore } from '../../store/gameStore';
import { MissionCard } from './MissionCard';

const HIDDEN_PHASES = new Set(['setup', 'game_over', 'mission_draft']);

export function CurrentRoundMissionStrip() {
  const game = useGameStore((s) => s.game);
  const { phase, players } = game;
  const human = players[HUMAN_PLAYER_INDEX];

  if (!human || HIDDEN_PHASES.has(phase)) return null;
  if (!human.selectedMissionId) return null;

  const selectedMission = MISSION_BY_ID[human.selectedMissionId];
  if (!selectedMission) return null;

  const showCurrentRound =
    phase !== 'mission_select' && phase !== 'round_roll';

  if (!showCurrentRound) return null;

  return (
    <div className="overlay-panel flex items-center gap-3 p-2">
      <h2 className="shrink-0 text-xs font-semibold uppercase tracking-wide text-amber-200/80">
        이번 미션
      </h2>
      <div className="min-w-0 flex-1 overflow-x-auto">
        <MissionCard mission={selectedMission} variant="compact" />
      </div>
    </div>
  );
}
